var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.$props.json_config.images),function(image,index){return _c('div',{key:'div_img_'+index,class:'col-sm-12 col-md-'+image.cols},[_c('img',{attrs:{"src":image.url,"width":image.width,"height":image.height,"alt":image.alt}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }